import dom, { Fragment } from "../../../../../../dist/jsx-render/dom";
import { MatrixCell } from "./MatrixCell";
import { MatrixRow } from "./MatrixRow";
import { MatrixExport } from "./MatrixExport";
import { MatrixCommand } from "./MatrixCommand";
import { app } from "../../../../../Frame/App";
import { Constants } from "../../../../../Common/constants";
import { ButtonComponent } from "../../../../../Components/ButtonComponent";

var focusCell: MatrixCell;
export var lastFocusCell: MatrixCell;

class FieldContent {
    name: string;
    used: boolean;
    nameUsed: boolean;
}

class WidgetModel {
    widgetFields?: { [field: string]: string } = {};
    widgetIterationDate?: Date;
}

export interface FieldContentMap {
    [id: string]: FieldContent;
}

export class MatrixObject {
    name: string;
    multiRow: boolean;
    multiRowValue: number;
    guid: string;
    fixedRows: number;
    fixedColumns: number;
    version: number;

    tabName: string;
    tabGroup: string;

    rows: MatrixRow[];
    control: HTMLTableElement;
    fontSize: number;
    fields: FieldContentMap;
    defaultWidth: number;
    minWidth: number;
    useExcelImport: boolean;
    isReadonly: boolean;

    iterationType?: number;
    iterationDateFieldId: number;
    // Guid value used to be sure that even new fields can be used as iteration date.
    iterationDateFieldGuid: string;
    iterationOffset: number;
    iterationEndDateFieldId?: number;
    // Guid value used to be sure that even new fields can be used as iteration date.
    iterationEndDateFieldGuid: string;
    iterationEndDateOffset?: number;
    iterationFirstColumn: number;
    iterationNumberOfColumns: number;
    iterationCount: number;
    intervalType?: number;

    dynamicElements: HTMLElement[] = [];
    fieldNames: { [id: string]: string } = {};
    containerElement: HTMLElement;
    additionalMultiRows?: number[] = [];

    useInWidget?: boolean;
    widgetModel: WidgetModel;

    constructor(matrixFieldList: FieldContentMap/*, ereignisBlockId: string*/) {
        this.rows = new Array<MatrixRow>();
        this.fontSize = 12;
        this.defaultWidth = 80;
        this.minWidth = 30;
        this.fields = matrixFieldList;

        this.widgetModel = new WidgetModel();

        // Ereignisblock is now determined by the block the matrix field is part of.
        //this.ereignisBlockId = ereignisBlockId;

        // Is set via Checkbox
        //this.useExcelImport = (matrixFieldList == null && ereignisBlockId == null);
    }

    addRow(): MatrixRow {
        var row = new MatrixRow(this, this.rows.length);
        this.rows.push(row);
        return row;
    }

    validate(): void {
        var error = false;

        // check cell count
        if (this.rows.length > 0) {
            var cellCount = this.rows[0].cells.length;
            for (var i = 1; i < this.rows.length; i++) {
                if (this.rows[i].cells.length != cellCount) {
                    error = true;
                    break;
                }
            }

            if (error) {
                this.dump();
            }
        }
    }

    dump() {
        var str = "matrix validation failed:\n";
        for (var rowIdx = 0; rowIdx < this.rows.length; rowIdx++) {
            var row = this.rows[rowIdx];
            for (var cellIdx = 0; cellIdx < row.cells.length; cellIdx++) {
                var cell = row.cells[cellIdx];
                str += cell.type + " ";
            }
            str += "\n";
        }
        alert(str);
    }

    createMatrix(rootDivId: string): void {
        try {
            // create table
            var rootDiv = document.getElementById(rootDivId);
            this.control = document.createElement('table');
            this.control.id = 'mxtbl';

            // create body
            var tbody = document.createElement('tbody');

            for (var j = 0; j < this.rows.length; j++)
                this.rows[j].createRow(tbody, null);

            // append controls to DOM
            this.control.appendChild(tbody);
            rootDiv.appendChild(this.control);

            this.updateModelState();
            this.validate();

            if (!this.useExcelImport) {
                this.registerHandler();
                MatrixObject.updateButtons(null);
            }
        }
        catch (err) {
            alert("MatrixObject: error in createMatrix: " + err.message);
        }
    }

    save(): string {
        var exporter = new MatrixExport(this);
        return exporter.getJson();
    }

    updateModelState(): void {
        if (!this.useExcelImport) {
            // remove field usage
            for (var key in this.fields) {
                this.fields[key].used = false;
                this.fields[key].nameUsed = false;
            }
        }

        // update all rows
        for (var rowIndex = 0; rowIndex < this.rows.length; rowIndex++)
            this.rows[rowIndex].updateModelState(rowIndex);

        // consistency check
        this.validate();
    }

    hasFieldInMatrix(): boolean {
        if (!this.useExcelImport) {
            for (var key in this.fields) {
                if (this.fields[key].used)
                    return true;
            }
        }
        return false;
    }

    getFieldName(id: string): string {
        if (!this.useExcelImport) {
            if (id && id.length > 0) {
                if (this.fields[id] != null) {
                    return this.fields[id].name;
                }
                else {
                    return "?" + id + "?";
                }
            }
        }
        return null;
    }

    setFieldUsed(id: string, used: boolean): void {
        if (!this.useExcelImport) {
            if (id && id.length > 0 && this.fields[id] != null)
                this.fields[id].used = used;
        }
    }

    setFieldNameUsed(id: string, used: boolean): void {
        if (!this.useExcelImport) {
            if (id && id.length > 0 && this.fields[id] != null)
                this.fields[id].nameUsed = used;
        }
    }

    hasMergedCellsInColumn(colIndex: number): boolean {
        for (var i = 0; i < this.rows.length; i++) {
            var row = this.rows[i];
            if (row.cells[colIndex].isInColSpan || row.cells[colIndex].colSpan > 1)
                return true;
        }
        return false;
    }

    hasMergedCellsInRow(rowIndex: number): boolean {
        for (var i = 0; i < this.rows[rowIndex].cells.length; i++) {
            var cell = this.rows[rowIndex].cells[i];
            if (cell.isInRowSpan || cell.rowSpan > 1)
                return true;
        }
        return false;
    }

    registerHandler(): void {
        // insert column to the left
        $("#matrixImageColBefore").on("click", function () {
            MatrixCommand.insertColumnToLeft(lastFocusCell);
        });

        // insert column to the right
        $("#matrixImageColAfter").on("click", function () {
            MatrixCommand.insertColumnToRight(lastFocusCell);
        });

        // delete column
        $("#matrixImageColDelete").click(function () {
            MatrixCommand.deleteColumn(lastFocusCell);
        });

        // move column to left
        $("#matrixImageColMoveLeft").click(function () {
            MatrixCommand.moveColumnToLeft(lastFocusCell);
        });

        // move column to right
        $("#matrixImageColMoveRight").click(function () {
            MatrixCommand.moveColumnToRight(lastFocusCell);
        });

        // increase column width
        $("#matrixImageColLarger").click(function () {
            MatrixCommand.increaseColumnWidth(lastFocusCell);
        });

        // decrease column width
        $("#matrixImageColSmaller").click(function () {
            MatrixCommand.decreaseColumnWidth(lastFocusCell);
        });

        // insert row above
        $("#matrixImageRowBefore").click(function () {
            MatrixCommand.insertRowAbove(lastFocusCell);
        });

        // insert row below
        $("#matrixImageRowAfter").click(function () {
            MatrixCommand.insertRowBelow(lastFocusCell);
        });

        // delete row
        $("#matrixImageRowDelete").click(function () {
            MatrixCommand.deleteRow(lastFocusCell);
        });

        // move row up
        $("#matrixImageRowMoveUp").click(function () {
            MatrixCommand.moveRowUp(lastFocusCell);
        });

        // move row down
        $("#matrixImageRowMoveDown").click(function () {
            MatrixCommand.moveRowDown(lastFocusCell);
        });

        // merge right
        $("#matrixImageCellMergeCol").click(function () {
            MatrixCommand.mergeCellRight(lastFocusCell);
        });

        // split right
        $("#matrixImageCellSplitCol").click(function () {
            MatrixCommand.splitCellRight(lastFocusCell);
        });

        // merge down
        $("#matrixImageCellMergeRow").click(function () {
            MatrixCommand.mergeCellDown(lastFocusCell);
        });

        // split down
        $("#matrixImageCellSplitRow").click(function () {
            MatrixCommand.splitCellDown(lastFocusCell);
        });

        // text to field
        $("#matrixImageCellToField").on("click", function () {
            MatrixCommand.textToField(lastFocusCell);
        });

        // field to text
        $("#matrixImageCellToText").on("click", function () {
            MatrixCommand.fieldToText(lastFocusCell);
        });

        // select field
        $("#matrixImageEditField").on("click", () => {
            MatrixObject.openFieldSelectPopup();
        });
    }

    static updateButtons(cell: MatrixCell): void {
        lastFocusCell = focusCell;
        focusCell = cell;
        if (cell) {
            $("#matrixImageColBefore").removeClass("disabled");
            $("#matrixImageColAfter").removeClass("disabled");

            if (cell.canDeleteColumn())
                $("#matrixImageColDelete").removeClass("disabled");
            else
                $("#matrixImageColDelete").addClass("disabled");

            if (cell.canMoveColumnLeft())
                $("#matrixImageColMoveLeft").removeClass("disabled");
            else
                $("#matrixImageColMoveLeft").addClass("disabled");

            if (cell.canMoveColumnRight())
                $("#matrixImageColMoveRight").removeClass("disabled");
            else
                $("#matrixImageColMoveRight").addClass("disabled");

            if (cell.canIncreaseColumn())
                $("#matrixImageColLarger").removeClass("disabled");
            else
                $("#matrixImageColLarger").addClass("disabled");

            if (cell.canDecreaseColumn())
                $("#matrixImageColSmaller").removeClass("disabled");
            else
                $("#matrixImageColSmaller").addClass("disabled");

            if (cell.canInsertRowAbove())
                $("#matrixImageRowBefore").removeClass("disabled");
            else
                $("#matrixImageRowBefore").addClass("disabled");

            if (cell.canInsertRowBelow())
                $("#matrixImageRowAfter").removeClass("disabled");
            else
                $("#matrixImageRowAfter").addClass("disabled");

            if (cell.canDeleteRow())
                $("#matrixImageRowDelete").removeClass("disabled");
            else
                $("#matrixImageRowDelete").addClass("disabled");

            if (cell.canMoveRowUp())
                $("#matrixImageRowMoveUp").removeClass("disabled");
            else
                $("#matrixImageRowMoveUp").addClass("disabled");

            if (cell.canMoveRowDown())
                $("#matrixImageRowMoveDown").removeClass("disabled");
            else
                $("#matrixImageRowMoveDown").addClass("disabled");

            if (cell.canMergeRight())
                $("#matrixImageCellMergeCol").removeClass("disabled");
            else
                $("#matrixImageCellMergeCol").addClass("disabled");

            if (cell.canSplitRight())
                $("#matrixImageCellSplitCol").removeClass("disabled");
            else
                $("#matrixImageCellSplitCol").addClass("disabled");

            if (cell.canMergeDown())
                $("#matrixImageCellMergeRow").removeClass("disabled");
            else
                $("#matrixImageCellMergeRow").addClass("disabled");

            if (cell.canSplitDown())
                $("#matrixImageCellSplitRow").removeClass("disabled");
            else
                $("#matrixImageCellSplitRow").addClass("disabled");

            if (cell.isField()) {
                $("#matrixImageCellToField").addClass("disabled");
                $("#matrixImageCellToText").removeClass("disabled");
            }
            else {
                $("#matrixImageCellToField").removeClass("disabled");
                $("#matrixImageCellToText").addClass("disabled");
            }

            if (cell.isField())
                $("#matrixImageEditField").removeClass("disabled");
            else
                $("#matrixImageEditField").addClass("disabled");
        }
        else {
            $("#matrixImageColBefore").addClass("disabled");
            $("#matrixImageColAfter").addClass("disabled");
            $("#matrixImageColDelete").addClass("disabled");
            $("#matrixImageColMoveLeft").addClass("disabled");
            $("#matrixImageColMoveRight").addClass("disabled");
            $("#matrixImageColLarger").addClass("disabled");
            $("#matrixImageColSmaller").addClass("disabled");
            $("#matrixImageRowBefore").addClass("disabled");
            $("#matrixImageRowAfter").addClass("disabled");
            $("#matrixImageRowDelete").addClass("disabled");
            $("#matrixImageRowMoveUp").addClass("disabled");
            $("#matrixImageRowMoveDown").addClass("disabled");
            $("#matrixImageCellMergeCol").addClass("disabled");
            $("#matrixImageCellSplitCol").addClass("disabled");
            $("#matrixImageCellMergeRow").addClass("disabled");
            $("#matrixImageCellSplitRow").addClass("disabled");
            $("#matrixImageCellToField").addClass("disabled");
            $("#matrixImageCellToText").addClass("disabled");
            $("#matrixImageEditField").addClass("disabled");
        }
    }

    // show field select popup
    static openFieldSelectPopup = (): void => {
        if (lastFocusCell && lastFocusCell.isField()) {
            var matrixObject = lastFocusCell.row.matrixObject;

            // grey background
            //$('#masterScreenMask').fadeTo("fast", 0.7);

            let matrixFieldSelect = document.getElementById("matrix-field-select") as HTMLElement;
            app.destroyDomChildren(matrixFieldSelect);

            matrixFieldSelect.appendChild(<Fragment>
                <div className="field-select-header">
                    <span class="caption">{Resources.TemplateEditClient.selectField}</span>
                    <ButtonComponent additionalCssClasses="icon-edit fa fa-times close-button"
                        action={MatrixObject.hideFieldSelect} />
                </div>
                <div id="matrix-field-content">
                    <div className="field-entry empty">
                        <a className="field-link">
                            {Resources.Common.empty}
                        </a>
                    </div>
                </div>
            </Fragment>);

            let matrixFieldContent = matrixFieldSelect.querySelector("#matrix-field-content") as HTMLElement;
            let emptyEntry = matrixFieldSelect.querySelector(".empty") as HTMLElement;
            emptyEntry.addEventListener("click", MatrixObject.onFieldSelect);

            // fill unused fields

            for (var key in matrixObject.fields) {
                if (!matrixObject.fields[key].used || !matrixObject.fields[key].nameUsed) {
                    let entry: HTMLElement = <div className="field-entry">
                        <a className="field-link" key={key}>
                            {matrixObject.fields[key].name}
                        </a>
                        {!matrixObject.fields[key].nameUsed
                            ? <div className="icon icon-edit fas fa-tags use-field-name cursor-pointer"
                                title="Feldnamen anzeigen"
                                key={key}></div>
                            : []}
                    </div>;

                    entry.querySelector(".use-field-name")?.addEventListener("click", MatrixObject.onFieldNameSelect);

                    matrixFieldContent.appendChild(entry);

                    if (!matrixObject.fields[key].used) {
                        entry.querySelector(".field-link").addEventListener("click", MatrixObject.onFieldSelect);
                    } else {
                        entry.querySelector(".field-link").classList.add("disabled");
                    }
                }
            }

            // show popup
            matrixFieldSelect.classList.remove(Constants.cssClass_hidden);
            matrixFieldSelect.style.top = (window.innerHeight / 2 - matrixFieldSelect.clientHeight / 2) + "px";
            matrixFieldSelect.style.left = (window.innerWidth / 2 - matrixFieldSelect.clientWidth / 2) + "px";
        }
    }

    static onFieldSelect = (event: Event) => {
        let target = event.target as HTMLElement;
        MatrixCommand.onFieldSelect(target.getAttribute("key"), lastFocusCell);
        target.classList.add("disabled");
        target.removeEventListener("click", MatrixObject.onFieldSelect);
        //MatrixObject.hideFieldSelect();
    }

    static onFieldNameSelect = (event: Event) => {
        let target = event.target as HTMLElement;
        MatrixCommand.onFieldNameSelect(target.getAttribute("key"), lastFocusCell);
        app.destroyDomElements(target);
    }

    static onInputDoubleClick = (cell: MatrixCell): void => {
        if (cell && cell.isField()) {
            lastFocusCell = focusCell;
            MatrixObject.openFieldSelectPopup();
        }
    }

    static hideFieldSelect = () => {
        var popup = document.getElementById("matrix-field-select");
        popup.classList.add(Constants.cssClass_hidden);
        document.body.removeEventListener("click", MatrixObject.hideFieldSelect);
    }

    static fromJson(object: any, fieldList?: FieldContentMap): MatrixObject {
        let res: any;
        if (fieldList) {
            res = Object.assign(new MatrixObject(fieldList), object) as MatrixObject;
        } else {
            res = Object.assign(new MatrixObject(null), object) as MatrixObject;
        }
        res.rows = object.rows ? object.rows.map((r, index) => MatrixRow.fromJson(r, res, index)) : [];
        res.multiRow = object.multiRow && object.multiRow != 0 === true;
        res.multiRowValue = object.multiRow && object.multiRow != 0 ? object.multiRow : -1 ;
        return res;
    }
}
